import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 3C20.8513 3 26 8.14873 26 14.5C26 17.3155 24.9882 19.8947 23.3084 21.8938L28.7064 27.293C29.0969 27.6835 29.0969 28.3167 28.7064 28.7072C28.3459 29.0677 27.7787 29.0954 27.3864 28.7904L27.2922 28.7072L21.8938 23.3084C19.8947 24.9882 17.3155 26 14.5 26C8.14873 26 3 20.8513 3 14.5C3 8.14873 8.14873 3 14.5 3ZM14.5 5C9.25329 5 5 9.25329 5 14.5C5 19.7467 9.25329 24 14.5 24C19.7467 24 24 19.7467 24 14.5C24 9.25329 19.7467 5 14.5 5Z",
		fill: "currentColor"
	})
});
export default SvgMagnifyingGlass;
